// extracted by mini-css-extract-plugin
export default {"container":"AuthRoute_container__L0uBE","mainContainer":"AuthRoute_mainContainer__xEhVH"};